module.exports = __webpack_public_path__ + "static/media/Dither Background Image.42678a6d.jpg";